import {useProject} from "./useProject";
import useActivitySlice from "../useActivity/useActivitySlice";

const useActiveProject = () => {
  const {activeProjectId} = useActivitySlice();
  return useProject(activeProjectId);
};

export default useActiveProject;
